
import { payforOne } from '@/api/task/withdraw'
import { approvalRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
import { getType } from '@/utils/cookies'
@Component({
  name: 'approval',
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any

  private statusList: any[] = []
  // eslint-disable-next-line no-dupe-keys
  private setForm: any = {
    product: null,
    product_account: null,
    google_code: '',
  }
  private type: string = 'normal'
  private rules = approvalRules
  private loading: boolean = false
  private productList: any[] = []
  private accountList: any[] = []

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.setForm = {
      product: null,
      product_account: null,
      google_code: '',
    }
    this.$emit('close')
  }

  private async payforOneSave() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          ordernumber: this.info.ordernumber,
          ...this.setForm,
        }
        try {
          await payforOne(data).then(() => {
            this.$message({
              message: 'Approval successfully!',
              type: 'success',
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  // 获取产品列表
  private async getProductList() {
    await getProductList({
      product_type: this.info.product_type,
      currency: this.info.currency,
    }).then((res: any) => {
      this.productList = res
    })
  }

  private selProduct() {
    this.setForm.product_account = null
    if (this.type === 'normal') {
      this.getAccountList()
    }
  }

  private selProductType() {
    if (this.type === 'ant') {
      //   this.accountList = []
      //   this.setForm.product_account = null
      this.arr = []
    }
    // if (this.type === 'normal') {
    //   this.getAccountList()
    //   this.setForm.product_account = null
    // }
  }

  // 获取产品账户列表
  private async getAccountList() {
    const params = {
      product: this.setForm.product,
      type: this.type,
      status: 1,
      page: 1,
      page_size: 1000,
    }
    await getProductAccountList(params).then((res: any) => {
      this.accountList = res.results
    })
  }

  private arr: any = []
  private antAccountList: any = []
  private async remoteMethod(query) {
    if (query !== '') {
      const data: any = {
        name: query,
        product: this.setForm.product,
        type: this.type,
      }
      await getProductAccountList(data).then((res: any) => {
        this.antAccountList = res.results.filter(
          (item) => !this.accountList.some((item2) => item2.id === item.id)
        )
      })
    }
  }
  private changeArr(val) {
    // if (this.accountList.length > 1) {
    //   this.removeArr(val)
    // }
    let indexLen: number = val.length
    val.forEach((item, index, arr) => {
      let itemArr: any = item.split(',')
      let obj: any = {}
      obj.id = itemArr[0] - 0
      obj.account_name = itemArr[1]
      obj.state = itemArr[2] - 0
      obj.account_type = itemArr[3]
      if (indexLen - 1 === index) {
        this.accountList.push(obj)
      }
    })
    const map = new Map()
    this.accountList = this.accountList.filter(
      (v) => !map.has(v.id) && map.set(v.id, 1)
    )
    console.log(this.accountList, 'ooo')
  }
  private itemArr: any = []
  private removeArr(val) {
    this.itemArr = val.split(',')
    this.accountList = this.accountList.filter((item) => {
      return item.id !== this.itemArr[0] - 0
    })
  }

  private sysType: any = ''
  created() {
    this.sysType = getType()
    this.getProductList()
  }
}
